import React, { useState, useRef, useEffect } from "react";
import { IoIosSearch } from "react-icons/io";
import EnbdIcon from "../../../assests/enbd-icon.png"; // ✅ fallback if no logo

const AutocompleteSearchBox = ({
  placeholder = "Search product…",
  data = [], // [{ title, products: [] }]
  query,
  setQuery,
  logoIcon = {}, // ✅ logos from parent
}) => {
  const [results, setResults] = useState([]);
  const [show, setShow] = useState(false);
  const wrapperRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setShow(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Handle typing & filter
  const handleChange = (e) => {
    const val = e.target.value;
    setQuery(val);

    if (!val.trim()) {
      setResults([]);
      setShow(false);
      return;
    }

    // Filter per category
    const filtered = data
      .map((cat) => ({
        title: cat.title,
        products: cat.products.filter((p) =>
          p.name.toLowerCase().includes(val.toLowerCase())
        ),
      }))
      .filter((cat) => cat.products.length > 0);

    setResults(filtered);
    setShow(true);
  };

  const handleSelect = (product) => {
    setQuery(product.name);
    setShow(false);
  };

  return (
    <div className="position-relative search-bar-box" ref={wrapperRef} style={{ maxWidth: 423 }}>
      <div className="input-group">
        <span className="input-group-text border-0">
          <IoIosSearch />
        </span>
        <input
          type="search"
          className="form-control border-start-0"
          placeholder={placeholder}
          value={query}
          onChange={handleChange}
          onFocus={() => query && results.length && setShow(true)}
        />
      </div>

      {/* Dropdown */}
      {show && results.length > 0 && (
        <ul
          className="list-group position-absolute w-100 shadow-sm"
          style={{ zIndex: 1050, maxHeight: 250, overflowY: "auto" }}
        >
          {results.map((cat) => (
            <li
              key={cat.title}
              className="list-group-item px-2 py-1 bg-light fw-bold"
            >
              {cat.title}
              <ul className="list-unstyled mb-0">
                {cat.products.map((p, idx) => {
                  const logoId = p?.logo?.id;
                  const logoSrc = (logoId && logoIcon[logoId]) || EnbdIcon;
                  return (
                    <li
                      key={idx}
                      className="d-flex align-items-center px-2 py-1 list-group-item list-group-item-action"
                      onMouseDown={() => handleSelect(p)}
                      style={{ cursor: "pointer" }}
                    >
                      <img
                        src={logoSrc}
                        alt={p.name}
                        style={{ width: 20, height: 20, marginRight: 8 }}
                      />
                      {p.name}
                    </li>
                  );
                })}
              </ul>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default AutocompleteSearchBox;
